import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=348d8267"
import script from "./Text.vue?vue&type=script&lang=ts"
export * from "./Text.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348d8267')) {
      api.createRecord('348d8267', component.options)
    } else {
      api.reload('348d8267', component.options)
    }
    module.hot.accept("./Text.vue?vue&type=template&id=348d8267", function () {
      api.rerender('348d8267', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/Text.vue"
export default component.exports